import { lazy } from 'react'
import { Route } from 'commons/types/route'

const ParticipationConfirmationPage = lazy(() => import('pages/ParticipationConfirmation'))

export default [
  {
    path: '/participationConfirmation',
    component: ParticipationConfirmationPage,
  },
] as Route[]
